export const MuiButtonBase = (palette) => {
    return {
        root: {
            '&:focus-visible': {
                outline: 'revert',
                backgroundColor: palette.semantic.colorIconButtonFocus,
            },
            '&:active': { backgroundColor: palette.semantic.colorIconButtonPressed },
        },
    };
};
